// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2_I59","gfeWrapper":"CalendarEvent_gfeWrapper__10RZW"};